import React from 'react';
import { Link } from 'react-router-dom';
import Blog1 from '../../assets/images/blog1.png';
import Blog2 from '../../assets/images/blog2.png';

const blogData = [
    {
        id: 1,
        image: Blog1,
        date: 'Ianuarie 24, 2025',
        category: 'Marketing',
        comments: '5 comentarii',
        title: 'Cum te ajutăm să îți promovezi afacerea',
        tag: 'Marketing',
    },
    {
        id: 2,
        image: Blog2,
        date: 'Ianuarie 12, 2025',
        category: 'Arhivă',
        comments: '1 comentariu',
        title: 'De ce să alegi LUMO, top 5 motive',
        tag: 'Arhivă',
    },
];

function Blog() {
    return (
        <section className="blog_section row_am">
            <div className="container">
                <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                    <span className="title_badge">Ultimele noutăți</span>
                    <h2>
                        Vezi cele mai recente <span>postări pe blog</span>
                    </h2>
                </div>
                <div className="blog_listing">
                    {blogData.map((post) => (
                        <div className="blog_post" key={post.id} data-aos="fade-up" data-aos-duration={1500}>
                            <Link to="#" className="img">
                                <img src={post.image} alt="image" />
                            </Link>
                            <div className="text">
                                <ul className="blog_info">
                                    <li>{post.date}</li>
                                    <li>{post.category}</li>
                                    <li>{post.comments}</li>
                                </ul>
                                <h3>
                                    <Link to="#">{post.title}</Link>
                                </h3>
                                <div className="tag_more">
                                    <span className="tag">{post.tag}</span>
                                    <Link to="/">
                                        Citește mai mult <i className="icofont-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Blog;
